import { render, staticRenderFns } from "./WriterBankAccountEditModal.vue?vue&type=template&id=3c20e05c&scoped=true&"
import script from "./WriterBankAccountEditModal.vue?vue&type=script&lang=ts&"
export * from "./WriterBankAccountEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c20e05c",
  null
  
)

export default component.exports
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerDots});qInstall(component, 'directives', {ClosePopup});
